import type { Namespaces } from 'bundles/epic/__generated__/namespaces';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import type { MerchandisingHeroModuleFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';

export const getRegionalExperiment = () => {
  const experimentNames = [
    'regional2025JunePromoGlobal',
    'regional2025JunePromoGermany',
    'regional2025JunePromoUK',
    'regional2025JunePromoIndia',
    'regional2025JunePromoEmergingMarkets',
    'regional2025JunePromoLatam',
  ] as Array<keyof Namespaces['GrowthDiscovery']>;

  return experimentNames.find((name) => GrowthDiscoveryExperiments.get(name) === true);
};

export const getRegionName = (experimentName: keyof Namespaces['GrowthDiscovery']) => {
  switch (experimentName) {
    case 'regional2025JunePromoGlobal':
      return 'global';
    case 'regional2025JunePromoLatam':
      return 'latam';
    case 'regional2025JunePromoGermany':
      return 'germany';
    case 'regional2025JunePromoIndia':
      return 'india';
    case 'regional2025JunePromoUK':
      return 'uk';
    case 'regional2025JunePromoEmergingMarkets':
      return 'emerging';
    default:
      return '';
  }
};

export const getRegionalContent = (
  regionalHeroModules?: Array<MerchandisingHeroModuleFieldsFragment | null> | null,
  experimentName?: keyof Namespaces['GrowthDiscovery']
) => {
  if (!regionalHeroModules?.length || !experimentName) {
    return undefined;
  }

  return regionalHeroModules.find((module) => module?.region?.toLowerCase() === getRegionName(experimentName));
};
